/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useState } from "react";
import { Label } from "reactstrap";
import ItemLink from "./ItemLink";
import MoreInfoIcon from "./MoreInfoIcon";
import ItemLabel from "../util/Icons";
import ActionButton from "./ActionButton";
import ClipboardCopyButton from "./ClipboardCopyButton";

const ItemAttribute = ({
  title,
  titleTag="h5",
  text,
  textTag="h4",
  textStyle=null,
  placeholder = "Unknown",
  icon,
  image,
  moreInfo,
  exclamationInfo,
  type,
  item,
  copyButton = false,
  hideButton = false,
  className,
  onClick
}) => {
  // state
  const [hidden, setHidden] = useState(hideButton);
  const textValue = text ? text : placeholder;
  const renderText = hidden ? "••••••••••••••••" : textValue;

  return (
    <div className={className}>
      <ItemLabel className="no-spacing text-muted" tag={titleTag} icon={icon} image={image}>
        {title}
        {moreInfo && <>{' '}<MoreInfoIcon>{moreInfo}</MoreInfoIcon></>}
        {exclamationInfo && <>{' '}<MoreInfoIcon icon="exclamation-circle" iconColor={"red"}>{exclamationInfo}</MoreInfoIcon></>}
      </ItemLabel>
      {text != null && type && item ? (
        <ItemLink className="pb-2" tag={textTag} type={type} item={item} onClick={onClick}>
          {text}
        </ItemLink>
      ) : (
        <div className="d-flex">
          <Label
            className={`pb-2 ${onClick ? "link-primary clickable" : ""}`}
            tag={textTag}
            onClick={onClick}
            style={textStyle}
          >
            {renderText}
          </Label>
          {copyButton && <ClipboardCopyButton className="ms-1" copyValue={textValue} />}
          {hideButton && (
            <ActionButton
              className="ms-1"
              type={hidden ? "show" : "hide"}
              onClick={() => setHidden(prev => !prev)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ItemAttribute;
